var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgButtonArrowLeft = function SvgButtonArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 11",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.842 9.408L3.025 5.583l3.817-3.825L5.667.583l-5 5 5 5 1.175-1.175z",
    fill: "#F4AF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.842 9.408L3.025 5.583l3.817-3.825L5.667.583l-5 5 5 5 1.175-1.175z",
    fill: "currentColor",
    fillOpacity: 0.5
  })));
};
export default SvgButtonArrowLeft;